<form (ngSubmit)="close()" [formGroup]="deleteForm">
    <h2 mat-dialog-title>Eliminar documento</h2>
    <mat-dialog-content>
        <p>En nuevo se elimina. En respuesta o asignaci&oacute;n devuelve a recibido para archivo. Numeraciones no son reutilizadas.</p>
        <mat-form-field class="full-width">
            <mat-label>Observaci&oacute;n</mat-label>
            <input matInput formControlName="observation" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close cdkFocusInitial>No</button>
        <button mat-flat-button [disabled]="!deleteForm.valid">Eliminar</button>
    </mat-dialog-actions>
</form>
